import { render, staticRenderFns } from "./thank-you-view.vue?vue&type=template&id=22bbbea0&"
import script from "./thank-you-view.vue?vue&type=script&lang=ts&"
export * from "./thank-you-view.vue?vue&type=script&lang=ts&"
import style0 from "./thank-you-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22bbbea0')) {
      api.createRecord('22bbbea0', component.options)
    } else {
      api.reload('22bbbea0', component.options)
    }
    module.hot.accept("./thank-you-view.vue?vue&type=template&id=22bbbea0&", function () {
      api.rerender('22bbbea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/thank-you-view.vue"
export default component.exports